import React, { forwardRef } from 'react';
import Select from 'react-select'
import AsyncSelect from 'react-select/async';
import './componentsStyle.css'
const SelectInput = ({
    id,
    value,
    options,
    onChange,
    placeholder,
    isDisabled,
}) => {
    return (
        <Select
            id={id}
            isDisabled={isDisabled}
            value={value}
            onChange={onChange}
            options={options}
            placeholder={placeholder}
            isRtl
            isSearchable
            isClearable
            theme={theme => ({
                ...theme,
                borderRadius: 0,
                colors: {
                    ...theme.colors,
                    primary25: '#BAE3FF',
                    primary: '#BAE3FF',
                    neutral5: '#BAE3FF'
                },
            })}
            className="react-select-container disabled"
            classNamePrefix="react-select"
        />
    );
};


export const AsyncSelectInput = forwardRef(({ ...props }, ref) => (
    <AsyncSelect
        defaultOptions
        isRtl
        isSearchable
        isClearable
        backspaceRemovesValue
        escapeClearsValue
        placeholder=""
        theme={theme => ({
            ...theme,
            borderRadius: 0,
            colors: {
                ...theme.colors,
                primary25: '#BAE3FF',
                primary: '#BAE3FF',
                neutral5: '#BAE3FF'
            },
        })}
        className="react-select-container"
        classNamePrefix="react-select"
        menuPlacement='auto'
        noOptionsMessage={() => "لا توجد خيارات"}
        ref={ref}
        {...props}
    />
))

export default SelectInput;